/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Filesconfirmlowconfidence3Inputs */

const en_filesconfirmlowconfidence3 = /** @type {(inputs: Filesconfirmlowconfidence3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI is unsure (${i?.percent}%). Please verify.`)
};

const pt_filesconfirmlowconfidence3 = /** @type {(inputs: Filesconfirmlowconfidence3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A IA tem dúvidas (${i?.percent}%). Por favor verifique.`)
};

/**
* | output |
* | --- |
* | "AI is unsure ({percent}%). Please verify." |
*
* @param {Filesconfirmlowconfidence3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesconfirmlowconfidence3 = /** @type {((inputs: Filesconfirmlowconfidence3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesconfirmlowconfidence3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesconfirmlowconfidence3(inputs)
	return pt_filesconfirmlowconfidence3(inputs)
});
export { filesconfirmlowconfidence3 as "filesConfirmLowConfidence" }